import "./App.css";
import { Navbar } from "./Navbar";
import { ContactUs } from "./ContactUs";
import { AboutUs } from "./AboutUs";
import { MusicSection } from "./MusicSection";

function App() {
  return (
    <div className="App">
      <Navbar />
      <section id="home" className="hero">
        <div className="hero-content">
          {/* <h1 className="logo">CASCADE</h1> */}
          <img src="/images/CascadeLogo.png" alt="Band " className="logo" />

          <p className="tagline">New Music Soon - Vancouver Punk Rock</p>
        </div>
      </section>
      <AboutUs />
      <MusicSection />
      <ContactUs />
    </div>
  );
}

export default App;
